export type PartnerStatus = 'pending' | 'active' | 'rejected' | 'suspended';

export type PartnerCommissionStatus =
  | 'pending'
  | 'available'
  | 'processing'
  | 'paid'
  | 'reversed';

export type PartnerPayoutStatus = 'processing' | 'paid' | 'failed';

export type PartnerAttribution = 'link' | 'coupon';

export interface Partner {
  id: string;
  user_id: string;
  code: string;
  status: PartnerStatus;
  commission_rate: number;
  company_name: string;
  cnpj: string | null;
  stripe_connect_account_id: string | null;
  connect_onboarding_complete: boolean;
  crm_access_granted?: boolean;
  created_at: string;
  updated_at: string;
}

export interface PartnerReferral {
  id: string;
  partner_id: string;
  organization_id: string;
  attribution: PartnerAttribution;
  attributed_at: string;
  commission_ends_at: string;
}

export interface PartnerCommission {
  id: string;
  partner_id: string;
  organization_id: string;
  invoice_id: string | null;
  stripe_invoice_id: string;
  amount_paid: number;
  commission_amount: number;
  rate: number;
  status: PartnerCommissionStatus;
  available_at: string;
  payout_id: string | null;
  created_at: string;
}

export interface PartnerPayout {
  id: string;
  partner_id: string;
  amount: number;
  status: PartnerPayoutStatus;
  stripe_transfer_id: string | null;
  method: string;
  paid_at: string | null;
  created_at: string;
}

export const DEFAULT_COMMISSION_RATE = 0.25;
export const COMMISSION_HOLD_DAYS = 15;
export const MIN_PAYOUT_CENTS = 10000;
export const PARTNER_REF_COOKIE = 'adlitics_partner_ref';
export const PARTNER_REF_COOKIE_MAX_AGE_DAYS = 90;
